import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

type ToastKind = 'good' | 'bad' | 'info';
interface ToastState { msg: string; kind: ToastKind }

const ToastCtx = createContext<(msg: string, kind?: ToastKind) => void>(() => {});

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toast, setToast] = useState<ToastState | null>(null);

  const show = useCallback((msg: string, kind: ToastKind = 'info') => setToast({ msg, kind }), []);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 3500);
    return () => clearTimeout(t);
  }, [toast]);

  return (
    <ToastCtx.Provider value={show}>
      {children}
      {toast && <div className={`toast ${toast.kind === 'info' ? '' : toast.kind}`} role="status">{toast.msg}</div>}
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
